import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { formatMoment, parseMoment } from '@/shared/converters/dateConverters';
import User from '@/shared/models/User';
import { DossierId } from '../models/AbstractDossier';
import TestDrive from '../models/TestDrive';
import TestDriveData from '../models/TestDriveData';
import TestDriveReason from '../models/TestDriveReason';

const SCHEMA = {
  id: 'id',
  dossierId: 'dossierId',
  startTime: (data: any) => parseMoment(data.startTimestamp),
  startMileage: 'startMileage',
  endTime: (data: any) => parseMoment(data.finishTimestamp),
  endMileage: 'finishMileage',
  comment: 'comment',
  createdBy: (data: any) => User.withId(data.createdById),
  isCustomerPresent: 'isCustomerPresent',
  reason: (data: any) => parseReason(data.reason),
};

const REASON_SCHEMA = {
  id: 'id',
  description: 'description',
};

export function parseTestDrives(data: any): Array<TestDrive> {
  return parseEntities(data, SCHEMA, TestDrive);
}

export function parseTestDrive(data: any): TestDrive | null {
  return parseEntity(data, SCHEMA, TestDrive);
}

export function parseReason(data: any): TestDriveReason | null {
  return parseEntity(data, REASON_SCHEMA, TestDriveReason);
}

export function parseReasons(data: any): Array<TestDriveReason> {
  return parseEntities(data, REASON_SCHEMA, TestDriveReason);
}

export function formatTestDrive(data: TestDriveData, dossierId: DossierId): any {
  return {
    dossierId,
    startMileage: data.mileage,
    startTimestamp: formatMoment(data.time),
    finishMileage: null,
    endTime: null,
    comment: data.comment || null,
    isCustomerPresent: data.isCustomerPresent,
    reasonId: data.reason?.id ?? null,
  };
}

export function formatTestDriveUpdate(data: TestDriveData): any {
  return {
    finishMileage: data.mileage,
    finishTimestamp: formatMoment(data.time),
    comment: data.comment || null,
    isCustomerPresent: data.isCustomerPresent,
    reasonId: data.reason?.id ?? null,
  };
}
